<template>
  <main>
    <b-container>
      <div class="section-header">
        <div>
          <h1 class="heading">Pools</h1>
        </div>

        <div class="actions">
          <div class="action">
            <b-form-select
              v-model="projectId"
              :options="projectSelect"
              class=""
            ></b-form-select>
          </div>
          <div class="action">
            <b-form-input
              v-model="search"
              placeholder="Search…"
              class=""
            ></b-form-input>
          </div>
          <div class="action">
            <b-btn
              variant="primary"
              @click="isPoolAllowed()"
            >
              <i class="fa fa-plus" /> New pool
            </b-btn>
            <CustomAlert
              :visible="showAlert"
              title="Limit Exceeded"
              message="You have reached the usage limit of your company subscription plan.
              To extend it, please contact us at info@mynd-ware.com"
              @close="showAlert = false"
              />
          </div>
        </div>
      </div>

      <b-row>
        <b-col>
          <div class="nav nav-tabs border-0">
            <b-button
              class="btn-default nav-tab"
              v-bind:class="{ 'btn-creax': ifActiveType('Owner') }"
              @click="filterByOwnership('Owner')"
              >Pools Owned</b-button
            >
            <b-button
              class="btn-default nav-tab"
              v-bind:class="{ 'btn-creax': ifActiveType('Shared') }"
              @click="filterByOwnership('Shared')"
              >Pools Shared</b-button
            >
            <b-button
              class="btn-default nav-tab"
              v-bind:class="{ 'btn-creax': ifActiveType('ViewPool') }"
              @click="filterByOwnership('ViewPool')"
              >All Pools</b-button
            >
          </div>
        </b-col>
      </b-row>

      <div class="layoutcard">
        <!-- This table is for loading placeholders.
        Use this when you implement lazy loading. -->
        <!-- <table class="table table-hover vertical-align-middle">
          <thead>
            <tr>
              <th>
                <div class="placeholder">
                  <div class="placeholder__tile"></div>
                </div>
              </th>
              <th>
                <div class="placeholder">
                  <div class="placeholder__tile"></div>
                </div>
              </th>
              <th>
                <div class="placeholder">
                  <div class="placeholder__tile"></div>
                </div>
              </th>
              <th>
                <div class="placeholder">
                  <div class="placeholder__tile"></div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div class="placeholder">
                  <div class="placeholder__tile"></div>
                </div>
              </td>
              <td>
                <div class="placeholder">
                  <div class="placeholder__tile"></div>
                </div>
              </td>
              <td>
                <div class="placeholder">
                  <div class="placeholder__tile"></div>
                </div>
              </td>
              <td>
                <div class="placeholder">
                  <div class="placeholder__tile"></div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="placeholder">
                  <div class="placeholder__tile"></div>
                </div>
              </td>
              <td>
                <div class="placeholder">
                  <div class="placeholder__tile"></div>
                </div>
              </td>
              <td>
                <div class="placeholder">
                  <div class="placeholder__tile"></div>
                </div>
              </td>
              <td>
                <div class="placeholder">
                  <div class="placeholder__tile"></div>
                </div>
              </td>
            </tr>
          </tbody>
        </table> -->

        <b-table
          :show-empty="true"
          :items="poolsFiltered"
          :fields="fields"
          :filter="search"
          :current-page="currentPage"
          :per-page="perPage"
          class="table-hover vertical-align-middle"
          @filtered="onFiltered"
        >
          <template v-slot:cell(name)="data">
            <router-link
              :to="{
                name: 'PoolView',
                params: { id: data.item._id, ref: 'default' },
              }"
            >
              {{ data.item.name }}
            </router-link>
          </template>
          <template v-slot:cell(owner)="data">
            <b-badge variant="light">
              {{ data.item.created_by }}
            </b-badge>
          </template>
          <template v-slot:cell(projects)="data">
            <!-- <b-overlay no-center :show="loadingProjects">
                  <b-badge
                    v-for="(proj, n) in getProjects(data.item._id)"
                    :key="n"
                    class="mr-1"
                    variant="light"
                    @click="
                      $router.push({
                        name: 'ProjectView',
                        params: { id: proj.project_id },
                      })
                    "
                  >
                    {{ getProjectName(proj.project_id) }}
                  </b-badge>
                  <template #overlay>
                    <b-spinner small label="Small Spinner"></b-spinner>
                  </template>
                </b-overlay> -->
            <div class="placeholder" v-if="loadingProjects">
              <div class="placeholder__tile"></div>
            </div>
            <b-badge
              v-else
              v-for="(proj, n) in getProjects(data.item._id)"
              :key="n"
              class="mr-1"
              variant="light"
              @click="
                $router.push({
                  name: 'ProjectView',
                  params: { id: proj.project_id },
                })
              "
            >
              {{ getProjectName(proj.project_id) }}
            </b-badge>
          </template>
          <template v-slot:cell(description)="data">
            <div class="text-muted small text-fix">
              {{ data.item.description }}
            </div>
          </template>
          <template v-slot:cell(dbtype)="data">
            {{ data.item.dbtype | ucFirst }}
          </template>
          <template v-slot:cell(status)="data">
            {{ data.item.status.label }}
          </template>
          <template v-slot:cell(docs)="data">
            {{ data.item.stats.size }}
          </template>
          <template v-slot:cell(date)="data">
            {{ data.item.creationDate | moment("DD-MM-YYYY") }}
          </template>
          <template v-slot:cell(actions)="data">
            <b-btn-group>
              <b-btn
                :disabled="!data.item.user_allowed.includes('Owner')"
                variant="outline-secondary"
                size="sm"
                @click="
                  $router.push({
                    name: 'PoolEdit',
                    params: { id: data.item._id },
                  })
                "
              >
                <i class="fa fa-edit" />
              </b-btn>
              <b-btn
                :disabled="!data.item.user_allowed.includes('Owner')"
                variant="outline-secondary"
                size="sm"
                @click="confirmDelete(data.item)"
              >
                <i class="fa fa-trash" />
              </b-btn>
            </b-btn-group>
          </template>
          <template #empty>
            <div v-if="loadingPools">Loading Pools...</div>
            <div v-else>No pools found.</div>
          </template>
        </b-table>

        <b-row
          align-h="center"
          class="mt-4"
          v-if="poolsFiltered.length > perPage"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="poolsFiltered.length"
            :per-page="perPage"
          ></b-pagination>
        </b-row>
      </div>
    </b-container>
  </main>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import InitAdmin from "../Shared/InitAdmin";
import { mapState } from "vuex/dist/vuex.common.js";
import CustomAlert from "../Shared/CustomAlert.vue";

export default {
  name: "PoolIndex",
  extends: InitAdmin,
  components: {
    CustomAlert
  },
  data() {
    return {
      showAlert: false,
      search: "",
      currentPage: 1,
      perPage: 10,
      projectId: null,
      activePoolsList: "Owner",
      poolProjectsReference: [],
      loadingProjects: true,
      loadingPools: true,
      fields: [
        {
          key: "name",
        },
        {
          key: "owner",
        },
        {
          key: "projects",
        },
        {
          key: "description",
        },
        {
          key: "dbtype",
          tdClass: "",
          label: "Source",
        },
        {
          key: "status",
          tdClass: "text-muted d-none d-lg-table-cell",
        },
        {
          key: "docs",
          tdClass: "text-muted d-none d-lg-table-cell",
        },
        {
          key: "date",
          thClass: "text-right",
          tdClass: "text-right",
        },
        {
          key: "actions",
          tdClass: "text-right",
          label: "",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["poolsByDateDesc", "projectsByName"]),
    ...mapState({
      realmSettings: (state) => state.setting.realmSettings,
    }),
    projectSelect() {
      let projects = this.projectsByName.map((p) => {
        return { value: p._id, text: p.name };
      });
      return [
        { value: null, text: "Select project" },
        ...projects,
        { value: "NO_PROJECT", text: "No project" },
      ];
    },
    poolsFiltered() {
      let filtered = this.poolsByDateDesc;
      if (this.projectId === "NO_PROJECT") {
        filtered = this.poolsByDateDesc.filter(
          (pool) =>
            !this.poolProjectsReference.some((ref) => ref.pool_id === pool._id)
        );
      }

      if (this.projectId) {
        filtered = this.poolsByDateDesc.filter((pool) =>
          this.poolProjectsReference.some(
            (ref) =>
              ref.pool_id === pool._id && ref.project_id === this.projectId
          )
        );
      }

      if (this.activePoolsList === "Owner") {
        return filtered.filter((pool) =>
          pool.user_allowed.includes(this.activePoolsList)
        );
      }

      if (this.activePoolsList === "Shared") {
        return filtered.filter((pool) => !pool.user_allowed.includes("Owner"));
      }

      if (this.activePoolsList === "ViewPool") {
        return filtered.filter((pool) =>
          pool.user_allowed.includes(this.activePoolsList)
        );
      }
    },
  },
  watch: {
    projectId() {
      this.currentPage = 1;
    },
  },
  mounted() {
    this.loadingPools = true;
    this.loadPools().then(() => {
      this.loadingPools = false;
      this.projectsByName.forEach((project, n) => {
        this.loadProjectModels({ id: project._id }).then((models) => {
          models.forEach((model) => {
            model.pools.forEach((pool) => {
              this.poolProjectsReference.push({
                pool_id: pool.pool_id,
                project_id: project._id,
              });
            });
          });
          if (this.projectsByName.length === n + 1) {
            this.loadingProjects = false;
          }
        });
      });
    });
  },
  methods: {
    ...mapActions([
      "loadPools",
      "loadProjectModels",
      "loadProjects",
      "deletePool",
    ]),
    isPoolAllowed(){
      console.log(this.realmSettings.total_pools_created_)
      console.log(this.realmSettings.maxAllPools)
      if (this.realmSettings.total_pools_created_ === parseInt(this.realmSettings.maxAllPools) || this.realmSettings.total_pools_created_ > parseInt(this.realmSettings.maxAllPools ) ) {
        this.showAlert = true;  
        // alert("Pool Limits Excedded..");
          return;
      }
      this.$router.push({ name: 'PoolCreate', params: { ref: 'default' } })
      },
    confirmDelete(item) {
      if (item.pool_locked) {
        this.$toasted.show("Pool is locked, cant be deleted", {
          type: "error",
        });
      } else {
        this.$bvModal
          .msgBoxConfirm(
            `Are you sure you want to delete the pool “${item.name}”?`,
            this.$confirmOptions
          )
          .then((value) => {
            if (value) {
              this.deletePool({ id: item._id }).then((res) => {
                if (res === true) {
                  this.$toasted.show("Pool removed");
                } else {
                  this.$toasted.show(res, { type: "error" });
                }
              });
            }
          });
      }
    },
    onFiltered() {
      this.currentPage = 1;
    },
    getProjects(pid) {
      return this.poolProjectsReference.filter((p) => p.pool_id === pid);
    },
    getProjectName(pid) {
      return this.projectsByName.find((p) => p._id === pid).name;
    },
    ifActiveType(key) {
      return this.activePoolsList === key;
    },
    filterByOwnership(key) {
      this.activePoolsList = key;
    },
  },
};
</script>
